export default function getConsumptionType(type) {
    if (type === "SLP") return "Slp";
    else if (type === "RLM") return "Rlm";
    else return "";
}
